import { useDispatch } from "react-redux";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import { useCallback, useEffect, useRef, useState } from "react";
import { logAppsflyerAction } from "../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import {
    DepositQRCodeImageStyled,
    DepositQRCodeLeftStyled,
    DepositQRCodeNextStyled,
    DepositQRCodeRightStyled,
    DepositQRCodeStyled,
    DepositQRCodeSummaryRowStyled,
    DepositQRCodeSummaryStyled
} from "./styled/DepositQRCodeStyled";
import { Button } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import amountFormat from "../../../../utils/amountFormat";

function DepositQRCodeDesktop(props) {
    const dispatch = useDispatch();
    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent({module: 'Cashier'});
    const [isCopied, setIsCopied] = useState(false);
    const qrCodeImageContainerRef = useRef(null);

    const {
        onUnMountHandler,
        payload,
        selectedPayment,
        totalAmount,
    } = props;

    const handleCopyToClipboard = useCallback(() => {
        navigator.clipboard.writeText(payload?.qr_code_code).then();
        setIsCopied(true);
        handleGTMClick({button: 'copy_pix_key'});
        dispatch(logAppsflyerAction({name: LOG_AF_EVENT_NAMES.CASHIER_PIX_KEY_COPY}));
    }, [payload, handleGTMClick, dispatch]);

    useEffect(() => {
        return () => {
            onUnMountHandler && onUnMountHandler()
        }
    }, [onUnMountHandler]);

    useEffect(() => {
        let timer;
        if (isCopied) {
            timer = setTimeout(() => {
                setIsCopied(false);
            }, 3000);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }
    }, [isCopied]);

    useEffect(() => {
        qrCodeImageContainerRef?.current?.scrollIntoView({block: "center"});
    }, []);

    return <DepositQRCodeStyled>
        <DepositQRCodeLeftStyled>
            <DepositQRCodeImageStyled ref={qrCodeImageContainerRef}>
                <img src={`data:image/jpg;base64,${payload?.qr_code_picture}`} alt={''}/>
            </DepositQRCodeImageStyled>
            {
                isCopied ? <Button
                    onClick={handleCopyToClipboard}
                    variant="info"
                    size="lg"
                    disabled={true}
                >
                    <BinIcon name="IcCheckMark"
                             className={'me-2'}
                             style={{fontSize: '1.3em', fill: 'var(--color-green)'}}/>
                    {getLangPath('pix_qr.copied')}
                </Button> : <Button
                    onClick={handleCopyToClipboard}
                    variant="primary"
                    size="lg"
                    disabled={isCopied}
                >
                    <BinIcon name="IcCopy"
                             className={'me-2'}
                             style={{fontSize: '1.3em', fill: 'black'}}/>
                    {getLangPath('pix_qr.copy_pix_key')}
                </Button>
            }
        </DepositQRCodeLeftStyled>
        <DepositQRCodeRightStyled>
            <DepositQRCodeNextStyled>
                <h6 className={'mb-3'}>{getLangPath('pix_qr.how_make_deposit')}</h6>
                <p className="bordered mb-1"><BinIcon name={'IcQrCode'}
                                                      className={'me-2'}/>{getLangPath('pix_qr.scan_code')}</p>
                <p className="center mb-1">{getLangPath('pix_qr.or')}</p>
                <p className="bordered"><BinIcon name={'IcCopy'}
                                                 className={'me-2'}/>{getLangPath('pix_qr.copy_key')}</p>
            </DepositQRCodeNextStyled>
            <DepositQRCodeSummaryStyled>
                <DepositQRCodeSummaryRowStyled>
                    <div>{getLangPath('deposit.you_deposit')}</div>
                    {
                        payload?.amount > 0 &&
                        <div className="amount fw400">
                            {selectedPayment?.currency_notional?.iso || ''} {amountFormat(payload.amount / 100, 2)}
                        </div>
                    }
                </DepositQRCodeSummaryRowStyled>
                <DepositQRCodeSummaryRowStyled>
                    <div className="color-white">{getLangPath('deposit.total_amount_with_bonus')}</div>
                    {
                        totalAmount > 0 &&
                        <div className="amount fw600">USD {amountFormat(totalAmount, 2)}</div>
                    }
                </DepositQRCodeSummaryRowStyled>
            </DepositQRCodeSummaryStyled>
        </DepositQRCodeRightStyled>
    </DepositQRCodeStyled>
}

export default DepositQRCodeDesktop;
